import React, { useState } from 'react';
import { uploadPremium } from '../../../redux/actions/upload';
import { connect } from 'react-redux';
import { StateModel } from '../../../redux/store';
import Button from '../../../components/button/Button';
import { removeNotifications } from '../../../utils/notificationUtils';

interface Premiumprops {
  uploadPremium: (file: any) => void;
  onCloseHandler: any;
  loading: boolean;
}

/**
 * Premium-Component
 *
 * @returns {JSX.Element} Usermanagement-Component
 * @constructor
 */
const Premium = ({ uploadPremium, onCloseHandler, loading }: Premiumprops) => {
  const defStringFileLabel = 'Datei auswählen';
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [selectedFile, setSelectedFile] = useState(defStringFileLabel);
  const [file, setFile] = useState<File>();

  const onClick = () => {
    removeNotifications();
    if (selectedFile) {
      uploadPremium(file);
      if (inputRef && inputRef.current) {
        inputRef.current.value = '';
        setSelectedFile(defStringFileLabel);
        setFile(undefined);
      }
    }
  };

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const file = e.target.files
      ? e.target.files[0]
      : new File(['Error'], 'error.xslx');
    if (file && e.target.files) {
      setSelectedFile(file?.name ?? '');
      setFile(e.target.files[0]);
    }
  };

  return (
    <div>
      {loading ? (
        <div>
          <p>Wird Eingelesen, bitte warten...</p>
        </div>
      ) : (
        <div className={'premium-wrapper'}>
          <label className={'fileselectionlabel'}>
            <input
              ref={inputRef}
              type='file'
              accept='.xlsx'
              name='uploadInput'
              onChange={e => {
                onChangeHandler(e);
              }}
            />
            <i className='fas fa-search fa-2x'></i>&nbsp;
            {selectedFile}
          </label>

          <Button
            disabled={selectedFile === defStringFileLabel}
            onClickHandler={onClick}
            key={33}
          >
            <i className='fas fa-plus-circle fa-2x'></i> &nbsp;Datei importieren
          </Button>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state: StateModel) => ({
  loading: state.Loading.loading,
});

export default connect(mapStateToProps, {
  uploadPremium,
})(Premium);
